import { useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone'
import { Button, Card, Alert, Form, Row, Col } from 'react-bootstrap';
import Loader from '../components/Loader';
import { labels } from "../config/config"
import { getDataFromFile, onShowMessage } from './../utils/utils';
import { useNavigate, useOutletContext } from 'react-router-dom';
import languages from '../config/languages.json'


function DocsImportScreen() {
    const [showError, setShowError] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);
    const [message, setMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false)
    const navigate = useNavigate()

    const { profileState } = useOutletContext();
    const { projectRole: { projectId } } = profileState
    const [extractionType, setExtractionType] = useState("none")
    const [fileFormat, setFileFormat] = useState("txt")
    const [maxTermNbr, setMaxTermNbr] = useState()
    const d = new Date();

    const [lang, setLang] = useState("none")
    const [label, setLabel] = useState(`YATEA_${d.getFullYear()}${d.getMonth() + 1}${d.getDate()}${d.getHours()}${d.getMinutes()}`)

    const getAcceptField = (type) => {
        const acceptMap = {
            txt: { 'text/plain': ['.txt'] },
            pdf: { 'application/pdf': ['.pdf'] },
            xml: { 'application/xml': ['.xml'] },
        };

        return acceptMap[type] || { 'text/plain': ['.txt'] };
    };

    const maxSize = 6e+8;
    const { isDragActive, getRootProps, getInputProps, acceptedFiles, isDragReject, fileRejections } = useDropzone({
        accept: getAcceptField(fileFormat),
        minSize: 0,
        maxSize
    });
    const isFileTooLarge = fileRejections.length > 0 && fileRejections[0].file.size > maxSize

    useEffect(() => {
        if (fileRejections.length > 0 || isDragReject) {
            if (isFileTooLarge) setMessage("Le fichier est trop volumineux !")
            else setMessage("Type de fichier non pris en charge")
            onShowMessage(setShowError, setMessage);
        }
    }, [fileRejections, isDragReject, isFileTooLarge])

    const handleImport = () => {
        const params = {
            label,
            lang: lang !== "none" ? lang : undefined,
            extraction: {}
        }
        if (extractionType !== "none") {
            params.extraction.engine = extractionType
            if (extractionType === "termsuite" && maxTermNbr) params.extraction.max_terms = maxTermNbr
            else if (extractionType === "yatea") params.extraction.format = fileFormat
        }

        getDataFromFile(
            "docs",
            acceptedFiles,
            projectId,
            setIsLoading,
            setMessage,
            setShowError,
            setShowSuccess,
            params,
            true,
            navigate,
        );
    }

    const labelHandleChange = (event) => {
        setLabel(event.target.value)
    }

    const changeLabel = (extractor) => {
        if (extractor === "yatea") {
            setLabel(`YATEA_${d.getFullYear()}${d.getMonth() + 1}${d.getDate()}${d.getHours()}${d.getMinutes()}`)
        } else if (extractor === "termsuite") {
            setLabel(`TSUIT_${d.getFullYear()}${d.getMonth() + 1}${d.getDate()}${d.getHours()}${d.getMinutes()}`)
        }
        setExtractionType(extractor)
    }

    return (
        <div>

            <div className="container-element">

                <div className="container text-center mt-5">
                    <h4 className="mb-3">Importer un corpus et extraire des termes</h4>
                    <p className="mb-5">{labels.documentsImport}</p>
                    <p>Choix de l’extracteur terminologique</p>
                    <div className='m-3 d-flex flex-column align-items-center' >
                        <Form.Control
                            as="select"
                            size="sm"
                            aria-label="Select extractor"
                            value={extractionType}
                            onChange={(event) => {
                                changeLabel(event.target.value)
                                if (event.target.value === "none") {
                                    setFileFormat("txt");
                                    setMaxTermNbr();
                                }
                            }}
                            style={{ width: "20%" }}
                        >
                            <option value={"none"}> - </option>
                            <option value={"yatea"}> Yatea </option>
                            <option value={"termsuite"}> TermSuite </option>
                        </Form.Control>
                        {extractionType !== "none" && <div
                            className='d-flex justify-content-between align-items-center mt-3'
                            style={{ width: "40%" }}
                        >
                            {extractionType === "yatea" && <>
                                Format des Fichiers
                                <Form.Control
                                    as="select"
                                    size="sm"
                                    aria-label="Membre de classe"
                                    value={fileFormat}
                                    onChange={(event) => {
                                        setFileFormat(event.target.value)
                                    }}
                                    style={{ width: "50%" }}
                                >
                                    <option value={"txt"}> TXT </option>
                                    <option value={"pdf"}> PDF </option>
                                    <option value={"xml"}> XML </option>
                                </Form.Control>
                            </>}
                            {extractionType === "termsuite" && <>
                                Nb de termes max
                                <Form.Control
                                    size="sm"
                                    aria-label="Membre de classe"
                                    value={maxTermNbr}
                                    onChange={(event) => {
                                        setMaxTermNbr(event.target.value)
                                    }}
                                    type="number"
                                    style={{ width: "50%" }}
                                />
                            </>}
                        </div>}

                        {extractionType !== "none" && <Form className="center" style={{ width: "40%" }}>
                            <Form.Group as={Row} className="mt-3" controlId="">
                                <Form.Label className="text-left" column sm="6" xs="12">
                                    Libellé
                                </Form.Label>
                                <Col className="pl-0" sm="6" xs="12">
                                    <Form.Control
                                        defaultValue={label}
                                        onChange={labelHandleChange}
                                    />
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} className="mt-3" controlId="">
                                <Form.Label className="text-left" column sm="6" xs="12">
                                    Langue
                                </Form.Label>
                                <Col className="pl-0" sm="6" xs="12">
                                    <Form.Control
                                        as='select'
                                        value={lang}
                                        onChange={(e) => {
                                            if (e.target.value !== "none")
                                                setLang(e.target.value)
                                            else setLang("none")
                                        }}
                                    >
                                        <option value={"none"} >Select...</option>
                                        {languages.map((language => (
                                            <option
                                                key={Object.keys(language)}
                                                value={Object.keys(language)}
                                            >{Object.values(language)}</option>
                                        )))}
                                    </Form.Control>
                                </Col>
                            </Form.Group>
                        </Form>}

                    </div>
                    <Alert className="mx-5" variant="success" show={showSuccess} >
                        Fichiers envoyés avec succès
                    </Alert>
                    <Alert className="alert-custom mx-5" variant="danger" show={showError} dismissible onClose={() => setShowError(false)}>
                        {message}
                    </Alert>

                    <div {...getRootProps()}>
                        <input {...getInputProps()} />
                        {!isDragActive &&
                            <Card>
                                <Card.Body>Cliquez ici ou déposez un fichier pour l'importer !</Card.Body>
                            </Card>

                        }
                        {isDragActive && !isDragReject &&
                            <Card>
                                <Card.Body>Déposez votre fichier ici !</Card.Body>
                            </Card>
                        }
                        {isDragReject &&
                            <Card>
                                <Card.Body className="text-warning mt-2">Le type de fichier n'est pas accepté !</Card.Body>
                            </Card>
                        }
                        {isFileTooLarge && (
                            <div className="text-danger mt-2">Le fichier est trop volumineux !</div>
                        )}
                    </div>
                    {
                        isLoading && <div className="m-2"><Loader>Envoi des documents ...</Loader></div>
                    }

                    <ul className="list-group mt-2">
                        {acceptedFiles.length > 0 && !isFileTooLarge && acceptedFiles.map(acceptedFile => (
                            <li className="list-group-item list-group-item-success" key={acceptedFile.name}>
                                {acceptedFile.name}
                            </li>
                        ))}
                    </ul>

                    <Button className="d-flex mx-auto mt-2" disabled={extractionType !== "none" && lang === "none"} onClick={handleImport}>Import</Button>

                    <p className="m-2 mt-4">{message}</p>
                </div>
            </div>
        </div >
    )
}

export default DocsImportScreen
